module.exports = __webpack_public_path__ + "static/Logo_Sobre_Oscuro-8a66078645ba100ae74c66399f9db854.png";